import iTable from "../../../../components/Table.vue";
import { processApi } from "../../../../utility/index"

export default {
    name: "NoteDetail",
    components: { iTable },
    data() {
        return {
            formLabelWidth: '100px',
            form: {
                noteTitle: '',
                companyName: '',
                describe: '',
                carFilePath: '',
                sceneFilePath: ''
            },
            imgList: [
                { src: '' },
                { src: '' },
                { src: '' },
                { src: '' },
            ],
            imgLists: [
                { src: '' },
                { src: '' },
                { src: '' },
                { src: '' },
            ],
            height: '320',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: false, 
                serialNumber: true,
            },
            columns: [
                {
                    prop: "companyName",
                    label: this.$t('common.companyName'),
                    align: "center",
                },
                {
                    prop: "feedbackContent",
                    label: this.$t('GovernmentRegulation.feedbackContent'),
                    align: "center",
                },
                {
                    prop: "feedbackTime",
                    label: this.$t('GovernmentRegulation.feedbackTime'),
                    align: "center",
                },
            ],
            operates: {
                width: 60,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        dialogFormVisible: false,
                        method: (index, row) => {
                            this.dialogDetailsFormVisible= true
                            this.id = row.id
                            this.getReplyDetails()
                        }
                    }
                ],
            },
            oddNum: '',
            dialogDetailsFormVisible: false,
            DetailsRorm: {
                companyName: '',
                feedbackContent: '',
                feedbackTime: '',
                feedbackFilePath: '',
            },
            FileList: [],
            imageUrl: '',
            dialogVisible: false,
            processImg: processApi,
            id: ''
        };
    },
    created() {
        this.oddNum = this.$route.query.oddNum
    },
    mounted() {
        this.getNoteDetails()
        this.getCompanyReply()
    },
    methods: {
        goback() {
            this.$router.push({ path: "/GovernmentRegulation/EnforcementNotes", query: {} })
        },
        getNoteDetails() {
            let param = {
                oddNum: this.oddNum,
            }
            this.$store.dispatch('EnforcementNotes/GET_GETNOTEDETAILS', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.form = res.data.data
                        this.form.carFilePath = res.data.data.carFilePath
                        this.form.sceneFilePath = res.data.data.sceneFilePath
                        this.imgList = []
                        if (this.form.carFilePath) {
                            var txt = this.form.carFilePath.split(',')
                            txt.map((item, index) => {
                                this.imgList.push({
                                    src: item
                                })
                            })
                        }
                        this.imgLists = []
                        if (this.form.sceneFilePath) {
                            var txt = this.form.sceneFilePath.split(',')
                            txt.map((item, index) => {
                                this.imgLists.push({
                                    src: item
                                })
                            })
                        }
                    }
                }
            })
        },
        getCompanyReply() {
            let param = {
                oddNum: this.oddNum,
            }
            this.$store.dispatch('EnforcementNotes/GET_GETCOMPANYREPLY', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data
                    }
                }
            })
        },
        getReplyDetails() {
            let param = {
                id: this.id,
            }
            this.$store.dispatch('EnforcementNotes/GET_GETCOMPANYREPLYDETAILS', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.DetailsRorm = res.data.data
                        this.DetailsRorm.feedbackFilePath = res.data.data.feedbackFilePath
                        this.FileList = []
                        if (this.DetailsRorm.feedbackFilePath) {
                            var txt = this.DetailsRorm.feedbackFilePath.split(',')
                            txt.map((item, index) => {
                                this.FileList.push({
                                    url: item
                                })
                            })
                        }
                    }
                }
            })
        },
    },
};
